import React, { useState } from 'react';
import './FullScreenResultsView.css';
import ShareWithBossModal from './ShareWithBossModal';

const FullScreenResultsView = ({ documentTitle, onCreateAnother, onBackToOverview, onLogoClick }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    const shareUrl = window.location.origin + window.location.pathname;
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleLinkedInShare = () => {
    const shareUrl = window.location.origin + window.location.pathname;
    const text = `Just created an amazing presentation with @Templafy's AI in minutes. The future of document creation is here!`;
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&summary=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <div className="fullscreen-results">
      {/* Left Sidebar */}
      <div className="results-sidebar">
        <div className="results-sidebar-header">
          <img src="/Templafy-logo-white.svg" alt="Templafy" className="results-sidebar-logo" onClick={onLogoClick} style={{ cursor: 'pointer' }} />
        </div>

        <div className="results-social-proof">
          <div className="social-proof-stat">
            <span className="stat-number">5,000+</span>
            <span className="stat-label">companies trust Templafy</span>
          </div>
          <div className="social-proof-logos">
            <div className="logo-placeholder">Enterprise ready</div>
          </div>
        </div>

        <div className="results-share-section">
          <h3 className="share-title">Share what you've seen</h3>
          <p className="share-text">
            Help your team discover a better way to create documents.
          </p>
          <div className="share-buttons">
            <button className="share-button linkedin" onClick={handleLinkedInShare}>
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <path d="M16 1H4a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3zM6 16H4V7h2v9zM5 6a1 1 0 110-2 1 1 0 010 2zm11 10h-2v-4.5c0-1.1-.9-2-2-2s-2 .9-2 2V16H8V7h2v1c.6-.6 1.5-1 2.5-1 1.9 0 3.5 1.6 3.5 3.5V16z" fill="currentColor"/>
              </svg>
              Share on LinkedIn
            </button>
            <button className="share-button copy" onClick={handleCopyLink}>
              <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                <g>
                  <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8.995,7.005 L8.995,7.005c1.374,1.374,1.374,3.601,0,4.975l-1.99,1.99c-1.374,1.374-3.601,1.374-4.975,0l0,0c-1.374-1.374-1.374-3.601,0-4.975 l1.748-1.698"/>
                  <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7.005,8.995 L7.005,8.995c-1.374-1.374-1.374-3.601,0-4.975l1.99-1.99c1.374-1.374,3.601-1.374,4.975,0l0,0c1.374,1.374,1.374,3.601,0,4.975 l-1.748,1.698"/>
                </g>
              </svg>
              {copied ? 'Copied!' : 'Copy link'}
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="results-main">
        <div className="results-header">
          <button className="results-back-button" onClick={onBackToOverview}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 19L5 5M19 5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>Back to overview</span>
          </button>
        </div>

        <div className="results-content">
          {/* Success Card */}
          <div className="success-card">
            {/* Animated Checkmark */}
            <div className="success-checkmark">
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                <circle className="checkmark-circle" cx="32" cy="32" r="30" stroke="#4A61ED" strokeWidth="2" fill="none"/>
                <path className="checkmark-check" d="M20 32L28 40L44 24" stroke="#4A61ED" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
              </svg>
            </div>

            <h1 className="success-title">Your {documentTitle} is ready!</h1>
            <p className="success-subtitle">Your AI-generated presentation is complete and ready to download.</p>

            {/* Document Preview */}
            <div className="document-preview">
              <img src="/frontpage.png" alt="Document preview" className="preview-image" />
            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              <button className="action-button secondary" onClick={onCreateAnother}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Create another
              </button>
              <button className="action-button primary">
                <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                  <path d="M12 11C12 11.5523 11.5523 12 11 12H1C0.447715 12 0 11.5523 0 11V10H12V11ZM7 4.17285L9.04297 2.12988L10.457 3.54395L6 8.00098L1.54297 3.54395L2.95703 2.12988L5 4.17285V0H7V4.17285Z" fill="currentColor"/>
                </svg>
                Download presentation
              </button>
            </div>
          </div>

          {/* Share with Boss CTA */}
          <div className="boss-cta-card">
            <div className="boss-cta-content">
              <div className="boss-cta-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="currentColor"/>
                </svg>
              </div>
              <div className="boss-cta-text">
                <h3>Think your boss would love this?</h3>
                <p>Send them a quick email about what Templafy can do for your team.</p>
              </div>
            </div>
            <button className="boss-cta-button" onClick={() => setShowShareModal(true)}>
              Share with your boss
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          {/* Value Props Grid */}
          <div className="value-props-grid">
            <div className="value-prop-card">
              <div className="value-prop-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>AI Drafting</h4>
              <p>Create documents in minutes, not hours</p>
            </div>
            <div className="value-prop-card">
              <div className="value-prop-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Always Compliant</h4>
              <p>Brand & legal guidelines built-in</p>
            </div>
            <div className="value-prop-card">
              <div className="value-prop-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Save 4+ Hours</h4>
              <p>Every week, per employee</p>
            </div>
          </div>

          {/* Final CTA */}
          <div className="final-cta">
            <p className="final-cta-text">Ready to transform how your team creates documents?</p>
            <a href="https://www.templafy.com/demo" className="final-cta-button" target="_blank" rel="noopener noreferrer">
              Request a Demo
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Share Modal */}
      {showShareModal && (
        <ShareWithBossModal onClose={() => setShowShareModal(false)} />
      )}
    </div>
  );
};

export default FullScreenResultsView;
